import { createFileRoute } from '@tanstack/react-router';

import { CheckoutPage } from '@/areas/settings/manufacturing/Settings/CheckoutPage/CheckoutPage';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/settings/_menu/organization/customer-portal/checkout-conditions',
)({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CheckoutPage />;
}
